/**
 * Account XP, levels and talent points (GDD §2).
 */

import type { EngineEvent, GameState, ResourceAmounts } from './types.js';
import { xpForNextLevel, xpForSpentResources } from './formulas.js';

/**
 * Mutates: add XP, cascade level-ups, grant 1 talent point per level (GDD §2).
 * Returns emitted events.
 */
export function grantXp(state: GameState, amount: number, at: number): EngineEvent[] {
  if (amount <= 0) return [];
  const events: EngineEvent[] = [];
  state.xp += amount;
  while (state.xp >= xpForNextLevel(state.level)) {
    state.xp -= xpForNextLevel(state.level);
    state.level += 1;
    state.talentPoints += 1;
    events.push({
      at,
      type: 'levelUp',
      message: `Account-Level ${state.level} erreicht — 1 Talentpunkt erhalten.`,
      data: { level: state.level },
    });
  }
  return events;
}

/** XP for construction spending: 1 XP per 1 000 resources (GDD §2). */
export function grantXpForSpending(state: GameState, cost: ResourceAmounts, at: number): EngineEvent[] {
  return grantXp(state, xpForSpentResources(cost), at);
}
